export const initializeClarity = (projectId) => {
  if (!projectId || typeof window === "undefined") return;

  (function (c, l, a, r, i, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };

    y = l.createElement(r);
    y.async = 1;
    y.src = "https://www.clarity.ms/tag/" + i;

    const t = l.getElementsByTagName(r)[0];
    t.parentNode.insertBefore(y, t);
  })(window, document, "clarity", "script", projectId);
};